
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"34","viewBox":"0 0 34 34","fill":"#fff","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M28.6 11.592H5.4V9.608h23.2v1.984z"}}),_c('path',{attrs:{"d":"M26.5 3.1v2h1.4v23.8H6.1V5.1h1.4v-2H4.1v27.8h25.8V3.1h-3.4z"}}),_c('path',{attrs:{"d":"M24.6 3.1h-2.8v4.7h2.8V3.1zm-12.4 0H9.4v4.7h2.8V3.1zm1.878.01v2h5.8v-2h-5.8z"}})])
          )
        }
      }
    